import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { FormField, useFormContext } from "../../../../../../components/Form";
import { Select } from "../../../../../../components/Inputs/Select";
import { TextInput } from "../../../../../../components/Inputs/TextInput";
import styles from "../../BirthDateFormInputs.module.scss";
export const YEAR_INPUT_MAX_LENGTH = 4;
export const YearInput = forwardRef(({ placeholder, onKeyUp, type, minimumAge }, yearInputRef) => {
    const { formState } = useFormContext();
    const currentYear = new Date().getFullYear();
    const endYear = currentYear - minimumAge;
    const startYear = 1900;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
        value: String(endYear - i),
        label: String(endYear - i),
    }));
    if (type === "select") {
        return (_jsx(FormField, { name: "year", validation: {
                required: true,
            }, ref: yearInputRef, className: styles.selectInput, render: ({ field }) => (_jsx(Select, { ...field, options: years, placeholder: placeholder, dataTestId: "year-input", isError: !!formState.errors.year, isSearchable: false, isIconHidden: true, menuPosition: "fixed" })) }));
    }
    return (_jsx(FormField, { name: "year", validation: {
            required: true,
            validate: {
                dateValid: (year) => year >= 1800 && year <= new Date().getFullYear(),
            },
        }, render: ({ field }) => (_jsx(TextInput, { placeholder: placeholder, maxLength: YEAR_INPUT_MAX_LENGTH, ...field, type: "tel", dataTestId: "year-input", ref: yearInputRef, onKeyUp: onKeyUp, isError: !!formState.errors.year })) }));
});
//# sourceMappingURL=YearInput.js.map